import { Component, OnInit } from '@angular/core';
import { format } from 'date-fns';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { StoresService } from '../../../core/services/stores.service';
import { IntlService } from '../../../core/services/intl.service';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxIntlTelInputModule } from 'untold-ngx-intl-tel-input';
import { AlertComponent } from '../../../shared-with-client/alert/alert.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-confirm-booking-drag-modal',
    templateUrl: './confirm-booking-drag-modal.component.html',
    styleUrls: ['./confirm-booking-drag-modal.component.scss'],
    imports: [FormsModule, NgxIntlTelInputModule, AlertComponent, DatePipe, TranslatePipe],
    standalone: true
})
export class ConfirmBookingDragModalComponent implements OnInit {
  public event;
  public newStart: Date;
  public newEnd: Date;
  public oldStart: Date;
  public oldEnd: Date;
  public startChanged: boolean;
  public type;

  public saving = false;
  public errorMsg = null;

  public notifyClient = false;
  timeFormatShort: string;
  public currentLocale = this.translate.currentLang;

  constructor(
    private modalService: BsModalService,
    private bsModalRef: BsModalRef,
    private storesService: StoresService,
    private intlService: IntlService,
    private translate: TranslateService
    ) {}

  ngOnInit(): void {
    this.timeFormatShort = this.intlService.getTimeFormatShort();
  }

  cancel() {
    this.modalService.setDismissReason(null);
    this.bsModalRef.hide();
  }

  confirm() {
    if (this.type === 'holiday') {
      this.saveHoliday()
    } else {
      this.saveBooking();
    }
  }

  saveHoliday() {
    this.saving = true;

    const payload = {
      dateEnd: format(this.newEnd, 'yyyy-MM-dd HH:mm'),
      dateInit: format(this.newStart, 'yyyy-MM-dd HH:mm'),
      providerId: this.event.provider?.id,
      reason: this.event.reason,
      storeId: this.event.store.id
    }

    this.storesService.editHoliday(this.event.id, payload).subscribe(
      (res) => {
        this.saving = false;
        this.modalService.setDismissReason('saved');
        this.bsModalRef.hide();
      },
      (err) => {
        this.errorMsg = err;
        this.saving = false;
      }
    );
  }

  saveBooking() {
    this.saving = true;

    const payload = {
      dateInit: format(this.newStart, 'yyyy-MM-dd HH:mm'),
      dateEnd: format(this.newEnd, 'yyyy-MM-dd HH:mm'),
      notifyClient: this.notifyClient,
    };

    this.storesService.rescheduleBooking(this.event.id, payload).subscribe(
      (res) => {
        this.saving = false;
        this.modalService.setDismissReason('saved');
        this.bsModalRef.hide();
      },
      (err) => {
        this.errorMsg = err.errMsg;
        this.saving = false;
      }
    );
  }
}
